import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class Test080325 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 08/03/2025 Candidates</h3>
      <br />
      <br />


        <div><Link to='/conduct-teerayutp'>1. AAT 2471  CAPT.TEERAYUT PAKDEEPAK(1DAN)---Trying for 2DAN</Link></div>
        <br />
        <div><Link to='/conduct-nitchakarnt'>2. AAT 7759  CPO.NITCHAKARN THAWORNKAN(2KYU)---Trying for 1KYU</Link></div>
        <br />
        <div><Link to='/conduct-sanphets'>3. AAT 7761  CPO.SANPHET SUKPRATHUEANG(2KYU)---Trying for 1KYU</Link></div>
        <br />
        <div><Link to='/conduct-tanapolp'>4. AAT 7864  RADM.TANAPOL PITAYAPAT(4KYU)---Trying for 3KYU</Link></div>
        <br />
        <div><Link to='/conduct-supachais'>5. AAT 7832  CPO.SUPACHAI SITTIRUK(5KYU)---Trying for 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-metapornc'>6. AAT 7833  MS.METAPORN CHIM-IM(5KYU)---Trying for 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-yanint'>7. AAT 7822  MS.YANIN TAIYANON(7KYU)---Trying for 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-sreytiah'>8. AAT 7892  MS. SREYTIA HEBBLETHWAITE(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-thomasm'>9. AAT 7923  MR.THOMAS MOENKEMEIER(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-napolp'>10. ATT  7910  MR.NAPOL PITAYAPAT(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-angieo'>11. ATT 7884  MS.ANGELICA JOSELINE OLSSON(9KYU)--Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-pongworakornp'>12. ATT  7926  MR.PONGWORAKORN PAOJEEN(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-uraveet'>13. ATT  7896  MS.URAVEE THEPWIMOLPETCHKUL(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-janicej'>14. ATT  7897  MS.JANICE JAMES(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-panupats'>15. ATT  7924  LT.PANUPAT SANSOOK(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-asdawutc'>16. ATT  7925  LT.ASDAWUT CHODSAPTHAWEE(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-nirunc'>17. AAT 7783  LT.NIRUN CHANTAWARO(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-andrewl'>18. AAT 7973  MR.ANDREW LINDQVIST(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-sunyal'>19. AAT 7972  CPO.SUNYA LAEID(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-panyaphatk'>20. AAT 7961  MR.PANYAPHAT KONGSEANG(WB)---Trying for 10KYU</Link></div>
        <br />





        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Test080325;
